module.exports = __webpack_public_path__ + "dc6caf51c6817c53f118d66e9e4a39f1.svg";